const projectData = [
    {
        id:1,
        projectName:"Decentralized File System(Source-Code)",
        demo:"https://github.com/riteshh-thakur/Decentralize-File-System/tree/main",
        imgsrc:"/Screenshot 2025-01-09 121353.png"
    },
    {
        id:2,
        projectName:"Guessing Game(Live)",
        demo:"https://clinquant-raindrop-c84a32.netlify.app/",
        imgsrc:"/Screenshot 2025-01-08 185713.png"
    },
    {
        id:3,
        projectName:"Expense-Tracker(Live)",
        demo:"https://ornate-brigadeiros-f1e694.netlify.app/",
        imgsrc:"/Screenshot 2025-01-08 185246.png"
    },
     {
        id:4,
        projectName:"Token-Stake-Dapp(Source-Code)",
        demo:"https://github.com/riteshh-thakur/Token-Staking-Dapp",
        imgsrc:"/Screenshot_28-2-2025_181636_localhost.jpeg"
    },
    {
        id:5,
        projectName:"Event-Management App",
        demo:"https://event-management-1-1nyc.onrender.com",
        imgsrc:"Screenshot 2025-02-07 011809.png"
    },
    {
        id:6,
        projectName:"Registration-Form(Live)",
        demo:"https://heroic-shortbread-25eb19.netlify.app/",
        imgsrc:"/Screenshot 2025-01-08 184547.png"
    },
    {
        id:7,
        projectName:"Image Resizing Application(Source-Code)",
        demo:"https://github.com/riteshh-thakur/Image-Resizing",
        imgsrc:"/Screenshot 2025-01-09 130618.png"
    },
    {
        id:8,
        projectName:"Signature-Website(Live)",
        demo:"https://signaturewebsite123.netlify.app/",
        imgsrc:"/signature-website.png"
    },
    {
        id:9,
        projectName:"Key-Logger(Live)",
        demo:"https://cosmic-gaufre-a0e0f3.netlify.app/",
        imgsrc:"/Screenshot 2025-01-08 191309.png"
    },
    {
        id:10,
        projectName:"Landing-Page(Live)",
        demo:"https://landingpppage.netlify.app/",
        imgsrc:"/Screenshot 2025-01-08 192204.png"
    },
    {
        id:11,
        projectName:"To-Do List(Live)",
        demo:"https://phenomenal-meerkat-55b3f0.netlify.app/",
        imgsrc:"/Screenshot 2025-01-09 141420.png"
    },
    {
        id:12,
        projectName:"Canva-Editor",
        demo:"https://67a1145caabe832ad69ea12b--fantastic-jalebi-d065b4.netlify.app/",
        imgsrc:"/Screenshot 2025-02-04 005301.png"
    },
    {
        id:13,
        projectName:"Note-Taking Web-App",
        demo:"https://note-taking-app-1-xqmw.onrender.com",
        imgsrc:"/Screenshot 2025-02-05 153712.png"
    },
]

export default projectData;
